import SelectPropertyConstants from '../constants/SelectPropertyConstants';

/**
 * Returns the listing intention path for given intention type
 *
 * @type - intention type one of: applications, leases, listing, payments
 * @listingId - the id of the listing
 *
 * @return - the path to the intended app
 */

const getPathByType = (type: keyof typeof SelectPropertyConstants, listingId: string) => {
  if (!type) {
    console.error('ERROR: type must be defined', type);

    return null;
  }

  if (!listingId) {
    console.error('ERROR: listingId must be defined', listingId);

    return null;
  }

  let path = '';

  // redirect to standalone apps
  switch (type) {
    case SelectPropertyConstants.APPLICATIONS as typeof type:
      path = `/rental-manager/applications/property/${listingId}`;
      break;

    case SelectPropertyConstants.LEASES as typeof type:
      path = `/rental-manager/leasing/property/${listingId}`;
      break;

    case SelectPropertyConstants.LISTINGS as typeof type:
      path = `/rental-manager/properties/${listingId}/listing`;
      break;

    case SelectPropertyConstants.PAYMENTS as typeof type:
      path = `/rental-manager/payments/properties/${listingId}`;
      break;

    default:
      break;
  }

  return path;
};

export default {
  getPathByType,
};
